<div class="card-modal">
    <header class="card-modal-header">
        <h4 class="card-modal-title">
            {{ showSummary ? ('USER_DISABLE.SUMMARY_TITLE' | translate) : ('USER_DISABLE.TITLE' | translate) }}
        </h4>
            
        <button type="button" class="btn-close pull-right" aria-label="Close" (click)="bsModalRef.hide()"></button>
    </header>

    <content>
        <div *ngIf="!onApplyProgressStep && !showSummary" class="m-4">
            <div class="alert alert-warning">
                <i class="bi bi-exclamation-triangle me-2"></i>
                {{ 'USER_DISABLE.CONFIRM_DISABLE' | translate:{count: userIds.length} }}
            </div>
        </div>

        <!-- Barra di progresso -->
        <div *ngIf="onApplyProgressStep && !showSummary" class="m-4 d-flex flex-column gap-3">
            <p class="mb-2">{{ 'USER_DISABLE.PROCESSING_USERS' | translate:{x: elementProcessed, y: totalElements} }}</p>
            <div class="progress" style="height: 10px;">
                <div class="progress-bar bg-success" role="progressbar" [style.width]="progressBarValue + '%'" 
                    aria-valuenow="progressBarValue" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="alert alert-warning mt-2">
                <i class="bi bi-exclamation-triangle me-2"></i> 
                {{ 'USER_DISABLE.ATTENTION_PROCESS_RUNNING' | translate }}
            </div>
        </div>

        <!-- Riepilogo risultati -->
        <div *ngIf="showSummary" class="m-4">
            <div class="d-flex flex-column gap-2 mb-4">
                <div class="d-flex gap-2 text-success">
                    <i class="bi bi-check-circle"></i> {{ 'USER_DISABLE.SUCCESS_COUNT' | translate:{count: successCount} }}
                </div>
                <div class="d-flex gap-2 text-danger">
                    <i class="bi bi-x-circle"></i> {{ 'USER_DISABLE.FAILURE_COUNT' | translate:{count: failureCount} }}
                </div>
            </div>

            <!-- Utenti con operazione riuscita -->
            <div *ngIf="successCount > 0" class="mb-4">
                <h5 class="mb-3 text-success">{{ 'USER_DISABLE.SUCCESSFUL_USERS' | translate }}</h5>
                <div class="list-group">
                    <div *ngFor="let result of processResults" class="list-group-item list-group-item-action" [class.list-group-item-success]="result.success">
                        <div *ngIf="result.success">
                            <i class="bi bi-check-circle-fill text-success me-2"></i>
                            <strong>{{ result.displayName }}</strong>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Utenti con operazione fallita -->
            <div *ngIf="failureCount > 0" class="mb-4">
                <h5 class="mb-3 text-danger">{{ 'USER_DISABLE.FAILED_USERS' | translate }}</h5>
                <div class="list-group">
                    <div *ngFor="let result of processResults" class="list-group-item list-group-item-action" [class.list-group-item-danger]="!result.success">
                        <div *ngIf="!result.success">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <i class="bi bi-x-circle-fill text-danger me-2"></i>
                                    <strong>{{ result.displayName }}</strong>
                                </div>
                            </div>
                            <small class="text-danger d-block mt-1">{{ result.errorMessage }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </content>
    
    <footer>
        <div class="d-flex gap-3 justify-content-center mt-3" *ngIf="!onApplyProgressStep && !showSummary">
            <div type="button" class="btn-gs-secondary-light" (click)="this.bsModalRef.hide()">
                {{ 'ACTIONS.CANCEL' | translate }}
            </div>
    
            <button type="button" class="btn-gs-primary" (click)="onSubmit()">
                {{ 'USER_DISABLE.DISABLE_USERS' | translate }}
            </button>
        </div>

        <div class="d-flex justify-content-center mt-3" *ngIf="showSummary">
            <button type="button" class="btn-gs-primary" (click)="closeModal()">
                {{ 'ACTIONS.CLOSE' | translate }}
            </button>
        </div>
    </footer>
</div>